<template>
	<v-dialog :value="dialog" max-width="760" @click:outside="cancel">
		<v-card>
			<v-card-title class="headline accent--text pb-4">Контакты</v-card-title>
				<v-card outlined tile class="border-top" style="padding: 16px 24px">
          <b>Телефон отдела планирования и организации учебного процесса:</b> <span>303-50-00 доб. 8135, 8133, 8534</span><br>
          <b>Режим работы:</b> 09:00 до 13.00; 13.30-17:30, выходные - суббота, воскресенье<br>
          <b>Заведующий отделом планирования и организации учебного процесса:</b> Синельникова Милена Валерьевна<br>
          <b>Адрес очной подачи документов:</b> 195067, Санкт-Петербург, Пискаревский пр., д. 47,  33 пав., 1 этаж, 115 кабинет
				</v-card>				

			<v-card-actions class="pr-4">
				<v-spacer></v-spacer>

				<v-btn color="lightGrey" text @click="cancel">
					Закрыть
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
  export default {
    props: {
			dialog: {
				type: Boolean
			}
		},

    mounted() {
      this.onResize()
      window.addEventListener("resize", this.onResize)
    },

    destroyed() {
      window.removeEventListener("resize", this.onResize)
    },


		methods: {
      onResize() {
        this.isTablet = window.innerWidth < 780
      },

			cancel() {
				this.$emit('closeContactsDialog')
			}
		}
  }
</script>

<style lang="sass" scoped>
  .border-top
    border: 0 !important
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important

  .tab
    color: #90a4ae !important
</style>